import { NotifyHelper } from "../../../helpers/toast";
import {
  eDmLoaiDangKyHocActionsObj,
} from "../../action-types/category/IDmLoaiDangKyHocActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const dmLoaiDangKyHocActions = {
  ...generateActions(eDmLoaiDangKyHocActionsObj, "LOAI_DANG_KY_HOC"),
  ...generateActionForKey(
    eDmLoaiDangKyHocActionsObj,
    "LOAI_DANG_KY_HOC",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDmLoaiDangKyHocActionsObj,
    "LOAI_DANG_KY_HOC",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDmLoaiDangKyHocActionsObj,
    "LOAI_DANG_KY_HOC",
    "SAVE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmLoaiDangKyHocActionsObj,
    "LOAI_DANG_KY_HOC",
    "DELETE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
